/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightCancellationQuoteCreateRequest
 */
export interface FlightCancellationQuoteCreateRequest {
  /**
   *
   * @type {string}
   * @memberof FlightCancellationQuoteCreateRequest
   */
  cancellationRequestId: string;
}

/**
 * Check if a given object implements the FlightCancellationQuoteCreateRequest interface.
 */
export function instanceOfFlightCancellationQuoteCreateRequest(
  value: object
): value is FlightCancellationQuoteCreateRequest {
  if (
    !("cancellationRequestId" in value) ||
    value["cancellationRequestId"] === undefined
  )
    return false;
  return true;
}

export function FlightCancellationQuoteCreateRequestFromJSON(
  json: any
): FlightCancellationQuoteCreateRequest {
  return FlightCancellationQuoteCreateRequestFromJSONTyped(json, false);
}

export function FlightCancellationQuoteCreateRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightCancellationQuoteCreateRequest {
  if (json == null) {
    return json;
  }
  return {
    cancellationRequestId: json["cancellation_request_id"],
  };
}

export function FlightCancellationQuoteCreateRequestToJSON(
  json: any
): FlightCancellationQuoteCreateRequest {
  return FlightCancellationQuoteCreateRequestToJSONTyped(json, false);
}

export function FlightCancellationQuoteCreateRequestToJSONTyped(
  value?: FlightCancellationQuoteCreateRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    cancellation_request_id: value["cancellationRequestId"],
  };
}
